<template>
	<TopicTemplate 
		:name="name" 
		:topicImage="topicImage" 
		:title="title"
		:type="type"
		:appointment="appointment"
		:summary="summary"
		:content="content"
		:result="result"
		:selected="selected">
	</TopicTemplate>
</template>
<script>

import AppointmentView from '../../mixin/appointment-view'
import TopicTemplate from './template/TopicTemplate'

export default {
	name: 'appointment-medication',
	data() {
		return {
			name: 'medication_question',
			topicImage: 'medication.png',
			type: 'medication',
			title: 'Medications'
		}
	},
	mixins: [ AppointmentView ],
	mounted() {
		('in medication')
	},
	components: {
		TopicTemplate
	}
}
</script>

<style lang="scss" scoped>
</style>